export default "__VITE_ASSET__DR5wVf6L__"